import {Component, h} from 'preact'
import ButtonControl from '../button-control'
import globals from '../../utils/globals'
import TextButton from '../ui-components/TextButton'
import InputGroup from '../ui-components/InputGroup'
import AnalyticsTooltip from '../ui-components/AnalyticsTooltip'
import Textarea from "../ui-components/Textarea";
import {Configuration, Provider} from "./types";
import AbstractProvider, {ProvidedItems} from "./AbstractProvider";
import AlertComponent from "../ui-components/AlertComponent";

interface Props {
  provider: Provider
  onMount: () => void
  onSubmit: (configuration: Configuration) => void
  ssoProxyUrl: string
}

interface State {
  showAlert: boolean
}

class SAMLSetup extends Component<Props, State> {
  metadataUrl = `${this.props.ssoProxyUrl}saml/metadata?customer=${globals('communityId')}`

  constructor(props: Props) {
    super(props)
    this.state = {
      showAlert: false
    }
    this.downloadMetadata = this.downloadMetadata.bind(this)
    this.copyMetadataUrl = this.copyMetadataUrl.bind(this)
  }

  downloadMetadata() {
    window.open(this.metadataUrl)
  }

  copyMetadataUrl() {
    const tmp = document.createElement('textarea')
    tmp.value = this.metadataUrl
    document.body.appendChild(tmp)
    tmp.select()
    document.execCommand('copy')
    document.body.removeChild(tmp)
    this.setState({ showAlert: true })
  }

  render (props: Props, state: State) {
    return <div>
      { state.showAlert &&  <AlertComponent
        messageType='success'
        message='Link copied!'
        isVisibleFor={5000}
        sticky
        onTimeoutEnd={() => this.setState({ showAlert: false })}
      />}
      <AbstractProvider {...props}>
      {({configuration, onSubmit, getError, getSubmitButtonProps, onInputChange}: ProvidedItems) =>
          <div className='form-enumeration'>
            <div className='form-enumeration__number'>1</div>
            <div className='form-enumeration__step-title'>Download metadata using the button below</div>
            <div className='form-enumeration__step-line'/>
            <div className='form-enumeration__step-content'>
              <ButtonControl
                  class='download-saml-metadata'
                  onClick={this.downloadMetadata}
                  title='Download metadata'
              />
              <TextButton class='copy-download-link' onClick={this.copyMetadataUrl}>
                Copy the download link
              </TextButton>
            </div>
            <div className='form-enumeration__number'>2</div>
            <div className='form-enumeration__step-title'>
              Configure identity provider information using metadata
            </div>
            <div className='form-enumeration__step-line'/>
            <div className='form-enumeration__step-empty'/>
            <div className='form-enumeration__number'>3</div>
            <div className='form-enumeration__step-title'>Fill in identity provider information</div>
            <div/>
            <div className='form-enumeration__step-content'>
              <p>Once you fill in these details and press 'Save changes', users on the community will
                be able to login using SSO, given all the information is provided is correct.</p>
              <form onSubmit={onSubmit}>
                <div>
                  {props.provider.fields.map(field => {
                    const error = getError(field.name)
                    return field.name == 'idp_public_key' ?
                        <div className='form-group'>
                          <label><span>{field.label} <AnalyticsTooltip
                              title={field.help ? field.help : ''}/></span></label>
                          <Textarea
                              value={configuration[field.name]}
                              onContentChange={(value: string) => onInputChange(field.name, value)}
                              class={`form-control ${error ? 'validation-error' : ''}`}
                          />
                          {error &&
                          <div className='validation-error error-message'>{error}</div>}
                        </div>
                        :
                        <InputGroup
                            title={<span>{field.label} <AnalyticsTooltip title={field.help ? field.help : ''}/></span>}
                            type='text'
                            value={configuration[field.name]}
                            onChangeCallback={(e: ChangeEvent) => onInputChange(field.name, e.target.value)}
                            error={getError(field.name) || undefined}
                        />
                  })}
                </div>
                <div>
                  <ButtonControl {...getSubmitButtonProps()} />
                  <ButtonControl
                      title='Cancel'
                      variant='secondary'
                      onClick={() => window.location.assign('/integration/sso')}
                  />
                </div>
              </form>
            </div>
          </div>
      }
    </AbstractProvider>
    </div>
  }
}

export default SAMLSetup
